export function startOfLocalDay(date = new Date()) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function formatLocalDateInput(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function parseLocalDateInput(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
}

export function addDays(base, days) {
  const d = startOfLocalDay(base);
  d.setDate(d.getDate() + Number(days));
  return d;
}

export function diffDaysFromToday(iso) {
  return diffDaysBetween(new Date(), iso);
}

/** API / display date → local calendar day */
export function toLocalDateInputIso(value) {
  if (!value) {
    return "";
  }
  if (/^\d{4}-\d{2}-\d{2}/.test(String(value))) {
    return String(value).slice(0, 10);
  }
  const d = startOfLocalDay(new Date(value));
  if (Number.isNaN(d.getTime())) {
    return "";
  }
  return formatLocalDateInput(d);
}

export function diffDaysBetween(from, toIso) {
  if (!toIso) {
    return 0;
  }
  const fromDay =
    typeof from === "string" && /^\d{4}-\d{2}-\d{2}/.test(from)
      ? startOfLocalDay(parseLocalDateInput(from))
      : startOfLocalDay(from instanceof Date ? from : new Date(from));
  const target = startOfLocalDay(parseLocalDateInput(toIso));
  return Math.round((target - fromDay) / (24 * 3600 * 1000));
}

export function tomorrowIso() {
  return formatLocalDateInput(addDays(new Date(), 1));
}

/**
 * UI: ISO-календарный день → «ДД.ММ.ГГ» (двузначный год, локальный разбор).
 * @param {string|null|undefined} value — `YYYY-MM-DD` или строка, нормализуемая через toLocalDateInputIso
 * @returns {string} «15.03.26» или «—»
 */
export function formatIsoDateShortDisplay(value) {
  const iso = toLocalDateInputIso(value);
  if (!iso) {
    return "—";
  }
  const [y, m, d] = iso.split("-");
  if (!y || !m || !d) {
    return "—";
  }
  const yy = String(Number(y) % 100).padStart(2, "0");
  return `${d}.${m}.${yy}`;
}
